import { FormEvent, useState } from 'react';
import { fleet, TimelineEntry } from '../api';
import { useAuth } from '../auth';
import { ago, dateTime } from '../format';

// Comments and automatic entries about a tracker or a vehicle, newest first.
export function Timeline({ subject, id, title, placeholder, entries, onChange }: {
  subject: 'trackers' | 'vehicles';
  id: number;
  title: string;
  placeholder: string;
  entries: TimelineEntry[];
  onChange: () => void;
}) {
  const { user } = useAuth();
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await fleet.comment(subject, id, text);
      setText('');
      onChange();
    } catch (err) {
      setError((err as Error).message);
    }
    setBusy(false);
  };

  const remove = async (entry: TimelineEntry) => {
    if (!window.confirm('Delete this comment?')) return;
    try {
      await fleet.deleteComment(entry.id);
      onChange();
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <section className="card form" aria-label={title}>
      <h2>{title}</h2>
      <form onSubmit={submit} className="form">
        <label className="sr-only" htmlFor={`comment-${subject}`}>Comment</label>
        <textarea id={`comment-${subject}`} rows={2} maxLength={2000} required value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} />
        {error && <p className="error" role="alert">{error}</p>}
        <div className="actions"><button className="primary" disabled={busy || !text.trim()}>Add comment</button></div>
      </form>
      {entries.length === 0 ? <p className="muted small">Nothing yet.</p> : (
        <ol className="feed">
          {entries.map((e) => (
            <li key={e.id} className={e.kind === 'auto' ? 'feed-auto' : ''}>
              <p className="feed-text">{e.text}</p>
              <p className="muted small">
                {e.kind === 'auto' ? 'Automatic' : e.by?.name ?? 'Someone'}
                {e.kind === 'auto' && e.by ? ` · ${e.by.name}` : ''}
                {' · '}<time dateTime={e.at} title={dateTime(e.at)}>{ago(e.at)}</time>
                {e.kind === 'comment' && (user?.role === 'admin' || e.by?.id === user?.id) && (
                  <> · <button className="link danger small" onClick={() => void remove(e)}>Delete</button></>
                )}
              </p>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
